import * as moment from 'moment';
import { MatchedMakpterolRow } from './vehicle-matching';

/** Build unencrypted values without using or mutating the manual costs form. */
export function buildImportedFuelCost(row: MatchedMakpterolRow, user: any, vehicles: any[], ddv: number, vendorId: number) {
  if (row.matchStatus !== 'matched' || row.vehicleid == null) {
    throw new Error('Возилото не е еднозначно пронајдено.');
  }
  if ([1, 2, 3].indexOf(row.fuelTypeId) === -1) {
    throw new Error('Типот на гориво не е препознаен.');
  }
  const vehicle = vehicles.find(item => item && String(item.vehicleid) === String(row.vehicleid));
  if (!vehicle || vehicle.typeid == null) {
    throw new Error('Недостасуваат податоци за возилото.');
  }
  const date = moment(row.date, 'YYYY-MM-DD', true);
  if (!date.isValid() || date.isAfter(moment(), 'day')) {
    throw new Error('Датумот на точење не е валиден.');
  }
  if (row.amount == null || !isFinite(row.amount) || row.quantity == null || !isFinite(row.quantity)) {
    throw new Error('Недостасува валиден износ или количина.');
  }
  if (ddv == null || !isFinite(ddv) || ddv < 0 || ddv > 100) {
    throw new Error('Недостасува валидна стапка на ДДВ.');
  }
  if (!row.invoiceNumber) {
    throw new Error('Недостасува број на фактура.');
  }
  if (user.ClientId == null || user.UserId == null) {
    throw new Error('Недостасува клиент или корисник.');
  }
  return {
    cid: user.ClientId,
    dateTime: row.date + ' 00:00:00',
    vehid: row.vehicleid,
    uid: user.UserId,
    description: 'Import od faktura broj ' + row.invoiceNumber,
    components: '',
    // Excel values are already MKD, litres and kilometres; do not convert them
    // using the display currency/distance/volume preferences of the user.
    price: row.amount,
    km: row.odometerKm != null && isFinite(row.odometerKm) && row.odometerKm >= 0 ? row.odometerKm : 0,
    pay: 'f',
    paygroup: '',
    driverid: -1,
    location: vendorId,
    type: 'fuel',
    lit: row.quantity,
    plit: 0,
    // Defaults from a new fuel entry in saveCosts().
    stype: 'Regular',
    costtypeid: 0,
    editid: -1,
    fuelcosttypeid: row.fuelTypeId,
    serialnumber: '',
    images: '',
    paymentimg: '/',
    paymentimg1: '/',
    paymentimg2: '/',
    invnum: row.invoiceNumber,
    maturcurrency: '',
    ddv,
    istruck: String(vehicle.typeid) === '4' ? '1' : '0',
    pricebycomp: '',
    ddvbycomp: '',
    selectedcompname: '',
    selectedcompids: [],
    arrzegin: [],
    arrvalues: []
  };
}



// WEBPACK FOOTER //
// ./src/pages/costs/makpterol-import/fuel-cost-payload.ts